import { EMPTY_OBJECT } from '../../constants/common'
import { BUILDING_OPTIONS_WITH_AVATAR_PARAMS } from '../Building'
import { toTableCellMultiValue } from '../Table'

import {
  DOC_FLOW_BUILDING_GROUP_OPTIONS_BUILDING_PARAM,
  DOC_FLOW_BUILDING_OPTIONS_BUILDING_GROUP_PARAM,
  DOC_FLOW_ENTITY_FIELD_BUILDING,
  DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP,
  DOC_FLOW_FORM_FIELD_BUILDING_GROUPS,
  DOC_FLOW_FORM_FIELD_BUILDINGS,
  DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING,
  DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING_GROUP,
} from './DocFlow.constants'

function hasDocFlowBuildingScope(docFlow) {
  return Boolean(
    docFlow?.[DOC_FLOW_ENTITY_FIELD_BUILDING] ||
    docFlow?.[DOC_FLOW_ENTITY_FIELD_BUILDING_GROUP]
  )
}

export function getDocFlowBuildingScopePayload(values) {
  return {
    [DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING]:
      values[DOC_FLOW_FORM_FIELD_BUILDINGS]?.value ?? null,
    [DOC_FLOW_FORM_PAYLOAD_FIELD_BUILDING_GROUP]:
      values[DOC_FLOW_FORM_FIELD_BUILDING_GROUPS]?.value ?? null,
  }
}

export function getDocFlowScopeBuildingApiParams(values) {
  const buildingGroupId = values[DOC_FLOW_FORM_FIELD_BUILDING_GROUPS]?.value

  return {
    ...BUILDING_OPTIONS_WITH_AVATAR_PARAMS,
    ...(buildingGroupId
      ? { [DOC_FLOW_BUILDING_OPTIONS_BUILDING_GROUP_PARAM]: buildingGroupId }
      : null),
  }
}

export function getDocFlowScopeBuildingGroupApiParams(values) {
  const buildingId = values[DOC_FLOW_FORM_FIELD_BUILDINGS]?.value

  return buildingId
    ? { [DOC_FLOW_BUILDING_GROUP_OPTIONS_BUILDING_PARAM]: buildingId }
    : EMPTY_OBJECT
}

// The backend only widens the search to archived users when a building scope
// is in play — the file's own filter or the doc flow's buildings.
export function isDocFlowMappingIncludeArchivedUnavailable({
  building,
  buildingGroup,
  docFlow,
}) {
  return !building && !buildingGroup && !hasDocFlowBuildingScope(docFlow)
}

export function toTableBuildingCellTextFromLabelTitle(data) {
  return {
    ...toTableCellMultiValue(data.label.title),
    key: data.value,
    src: data.label.avatar,
  }
}
